import React, { FC } from 'react';
import { useMsal } from '@azure/msal-react';
import { LogOut } from "lucide-react";
import { AuthenticationProps } from '../SignInButton/sign-in-button';
import Loader from '../../Base/Loader/Loader';

/**
 * Renders a sign-out button
 */
export const SignOutButton: FC<AuthenticationProps> = ({ isLoading }) => {
	const { instance, accounts } = useMsal();

	// eslint-disable-next-line no-unused-vars
	const logoutPopup = () => {
		instance
			.logoutPopup({
				postLogoutRedirectUri: '/',
				mainWindowRedirectUri: '/',
			})
			.catch((e) => {
				console.log(e);
				// Log the error to an external logging service
			});
	};

	const logoutRedirect = async () => {
		try {
			// Clear local storage
			localStorage.clear();
			sessionStorage.clear();
			
			const account = accounts[0];
			
			await instance.logoutRedirect({
				account: account,
				postLogoutRedirectUri: window.location.origin + '/login',
			});
		} catch (error) {
			console.error('Logout error:', error);
			window.location.href = '/login';
		}
	};

	const handleLogout = () => {
		logoutRedirect();
	};

	return (
		<button
			onClick={() => handleLogout()}
			disabled={isLoading}
			className="w-full flex gap-3 px-3 py-2 text-ui text-primary-text hover:bg-tertiary-background rounded-[36px] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
		>
			{isLoading ? (
				<Loader simple size={'sm'} />
			) : (
				<LogOut className="w-4 h-4" />
			)}
			{!isLoading && 'Log out'}
		</button>
	);
};
